<template> 
  <div class="mb-3" :class="FormDataType.FieldSize">
    <b-form-group
      :class="title_position"
      :label-cols-lg="labels_lg"
      id="example text"
      :label="FormDataType.FieldTitle"
      label-for="text"
    > 
      <b-form-input
        :class="{ 'is-invalid': v.$error }"
        v-model="InputName"
        :min="min" 
        :max="max"
        :type="FormDataType.FieldType"
        @input="$emit('input', InputName)"
        for="text"
        value=""
        :disabled="FormDataType.Disabled"
      ></b-form-input> 

      <div v-if="v.$error" class="invalid-feedback">
        <span v-if="v.required == false">{{  $t("ValidationMessage.required") }}</span>
        <span v-if="v.numeric == false">Bu Alan numeric.</span>
      </div>
    </b-form-group>
  </div> 
</template>

<script>
 
export default {
  data() {
    return {
      InputName: "",
    };
  },
 
  props: {
    v: {
      type: Object,
    },
    FormDataType: {},
    FormPost: String,
    Value: null,
    min: String,
    max: String,
    title_position: String,
    labels_lg: Number
  },
  watch: {
    FormPost() {
      this.$v.$touch();
    },
    Value(){
      this.InputName = this.Value;
    }
  },
  created: function () {
    this.InputName = this.Value;
  },
};
</script>
